// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c652068b","550":"c13cc1aa","703":"2775078a","787":"2a7103a8","921":"f7efe7ab"}[chunkId] + ".chunk.js";
};